import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { isMessageDescriptor } from '../types.js';
export const useMessage = () => {
    const intl = useIntl();
    return useMemo(() => {
        const formatMessage = (stringOrMessageDescriptor, values) => {
            let result = '';
            if (isMessageDescriptor(stringOrMessageDescriptor)) {
                result = intl.formatMessage(stringOrMessageDescriptor, values);
                if (result === ' ') {
                    // define optional message with single space
                    result = '';
                }
            }
            else if (!stringOrMessageDescriptor) {
                console.error('[INTL] Expected string or MessageDescriptor, but nothing given');
                result = '';
            }
            return result;
        };
        const lookup = (dict, key, values) => {
            const msg = dict[key];
            if (!msg) {
                console.warn(`[INTL] Value ${JSON.stringify(key)} not found in '${Object.keys(dict).join(`', '`)}'`);
                return null;
            }
            return formatMessage(msg, values);
        };
        const fallback = (messageIds, values) => {
            for (const id of messageIds) {
                if (!id)
                    continue;
                const messageDescriptor = isMessageDescriptor(id) ? id : { id };
                // @ts-ignore TODO: Refactor tech dept
                const result = intl.formatMessage(messageDescriptor, values);
                if (result === ' ')
                    return '';
                // TODO: do this better
                if (result && result !== id)
                    return result;
            }
        };
        formatMessage.lookup = lookup;
        formatMessage.fallback = fallback;
        return formatMessage;
    }, [intl]);
};
//# sourceMappingURL=useMessage.js.map